import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  NavbarChildDiv,
  NavbarChildLink,
  NavbarMainDiv,
  TitleContainer,
  Badge
} from './styles.js';

export default function MainMenuItem({ data, onClick, route }) {
  const accessLevel = useSelector(state => state.auth.accessLevel);
  const camerasNotification = useSelector(
    state => state.notification.camerasCount
  );
  const configNotification = useSelector(
    state => state.notification.configCount
  );

  const { parent_link, sublinks, acl } = data;

  const [isOpen, setIsOpen] = useState(true);
  function onClickOpen() {
    setIsOpen(!isOpen);
  }

  function renderItem() {
    if (acl) {
      if (acl > accessLevel) return null;
    }

    return (
      <>
        <NavbarMainDiv onClick={onClickOpen} active={isOpen}>
          {parent_link}
        </NavbarMainDiv>
        {isOpen &&
          sublinks.map(item => {
            if (item.acl) {
              if (item.acl > accessLevel) return null;
            }

            return (
              <NavLink key={item.link_route} to={item.link_route}>
                <NavbarChildDiv
                  onClick={() => onClick(item.link_route)}
                  active={item.link_route === route}
                >
                  <NavbarChildLink>
                    {item.link_route === '/configuracion-accesos' && (
                      <>
                        <TitleContainer>
                          {item.linkName}
                          {configNotification > 0 && (
                            <Badge>{configNotification}</Badge>
                          )}
                        </TitleContainer>
                      </>
                    )}

                    {item.link_route === '/camaras' && (
                      <TitleContainer>
                        {item.linkName}
                        {camerasNotification > 0 && (
                          <Badge>{camerasNotification}</Badge>
                        )}
                      </TitleContainer>
                    )}

                    {item.link_route !== '/camaras' &&
                      item.link_route !== '/configuracion-accesos' && (
                        <TitleContainer>{item.linkName}</TitleContainer>
                      )}
                  </NavbarChildLink>
                </NavbarChildDiv>
              </NavLink>
            );
          })}
      </>
    );
  }

  return renderItem();
}

MainMenuItem.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  route: PropTypes.string
};
